import CustomView from "@/domain/entities/customViews/CustomView";
import { useToast } from "@/hooks/utils/useToast";
import { queryKeys } from "@/lib/queryKeys";
import { customViewToSDKMapper } from "@/mappers/customView/customViewMapper";
import {
    CustomView as CustomViewSDK,
    useCustomViews,
} from "@cs_teamwaydev/mailvista-sdk_react";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

const useUpdateView = () => {
    const customViews = useCustomViews();
    const { toast } = useToast();
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const updateView = async (view: CustomView): Promise<boolean> => {
        try {
            const sdkView: CustomViewSDK = customViewToSDKMapper(view);
            if (!sdkView.id) {
                throw new Error("View ID is undefined");
            }
            await customViews.editView(sdkView.id, sdkView);
            queryClient.invalidateQueries({
                queryKey: queryKeys.customView.detail(view.id ?? ""),
            });
            queryClient.resetQueries({
                queryKey: queryKeys.mails.list(view.id ?? ""),
            });

            return true;
        } catch (error) {
            console.error(error);
            toast({
                title: t("errors.customViews.updateView"),
                description: t("errors.global.description"),
                variant: "error",
            });

            return false;
        }
    };

    return updateView;
};

export default useUpdateView;
